import * as React from 'react';

import {
  Text,
} from "@chakra-ui/react"

export const EffectsPage = () => {
  return (
      <Text>Effects page</Text>
  );
};

